import { render, staticRenderFns } from "./EditOrderFilers.vue?vue&type=template&id=81f395f8&"
import script from "./EditOrderFilers.vue?vue&type=script&lang=js&"
export * from "./EditOrderFilers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports